<template>
  <div>
    <h1 class="mt-5">Reporte de adopciones y pagos</h1>
    <br>

    <!-- Botón ojito -->
    <vs-button
      type="flat"
      class="p-2"
      icon-pack="fa"
      :icon="showTable ? 'fa-eye-slash' : 'fa-eye'"
      @click="showTable = !showTable"
      color="primary"
      title="Mostrar/Ocultar tabla"
    />

     <!-- Controles -->
    <div class="mt-3 flex flex-wrap items-center gap-3 md:gap-4">
      <!-- Botón cargar -->
      <vs-button @click="f_getReporte" class="p-2">
        <i class="fa-solid fa-rotate-right"></i> Cargar reporte
      </vs-button>

      <!-- Botón exportar -->
      <vs-button @click="f_exportar" color="success" class="p-2">
        <i class="fa-solid fa-file-arrow-down"></i> Exportar
      </vs-button>

      <!-- Select filtro distribuidor -->
      <div class="flex flex-col min-w-[220px] md:min-w-[250px]">
        <span>Filtrar por distribuidor:</span>
        <v-select
          :options="opcionesDistribuidor"
          :reduce="opt => opt.value"
          label="label"
          placeholder="--Seleccione--"
          v-model="filtroDistribuidor"
          class="w-full"
        />
      </div>
      <div>
        <ul class="leftx">
          <li class="flex">
            Tipo de venta
          </li>
          <li>
            <vs-radio v-model="tipoVenta" vs-name="radios1tipoVenta" vs-value="3">Todos</vs-radio>
          </li>
          <li>
            <vs-radio v-model="tipoVenta" vs-name="radios1tipoVenta" vs-value="1">Directa</vs-radio>
          </li>
          <li>
            <vs-radio v-model="tipoVenta" vs-name="radios1tipoVenta" vs-value="2">Lista</vs-radio>
          </li>

        </ul>
      </div>
    </div>

    <!-- Cards de Totales -->
    <div v-if="arrayFiltrado.length > 0" class="mt-6">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
        <div class="flex flex-col items-center justify-center bg-white border rounded-lg shadow p-6">
          <h3 class="text-sm text-gray-500">Adopciones</h3>
          <p class="text-4xl font-bold text-gray-800 mt-2">
            {{ totalVentaBruta | filtrarDecimal }}
          </p>
        </div>

        <div class="flex flex-col items-center justify-center bg-white border rounded-lg shadow p-6">
          <h3 class="text-sm text-gray-500">Adopciones - comisiones</h3>
          <p class="text-4xl font-bold text-gray-800 mt-2">
            {{ totalVentaNeta | filtrarDecimal }}
          </p>
        </div>

        <div class="flex flex-col items-center justify-center bg-white border rounded-lg shadow p-6">
          <h3 class="text-sm text-gray-500">Total Valor Comisión</h3>
          <p class="text-4xl font-bold text-blue-600 mt-2">
            {{ totalValorComision | filtrarDecimal }}
          </p>
        </div>

        <div class="flex flex-col items-center justify-center bg-white border rounded-lg shadow p-6">
          <h3 class="text-sm text-gray-500">Total Pagos</h3>
          <p class="text-4xl font-bold text-green-600 mt-2">
            {{ totalPagosConvenio | filtrarDecimal }}
          </p>
        </div>

        <div class="flex flex-col items-center justify-center bg-white border rounded-lg shadow p-6">
          <h3 class="text-sm text-gray-500">Total por Pagar</h3>
          <p class="text-4xl font-bold text-red-600 mt-2">
            {{ totalPorPagar | filtrarDecimal }}
          </p>
        </div>

      </div>
    </div>

    <!-- Tabla -->
    <vs-table
      v-if="showTable"
      max-items="10"
      search
      pagination
      :data="arrayFiltrado"
      class="mt-6"
      stripe
    >
      <template slot="header">
        <vs-chip color="primary">Cantidad: <b>{{ arrayFiltrado.length }}</b></vs-chip>
      </template>

      <template slot="thead">
        <vs-th width="250" sort-key="nombreInstitucion">Institución</vs-th>
        <vs-th width="120" sort-key="ventaBruta">Pedidos Venta Bruta</vs-th>
        <vs-th width="100" sort-key="comision">Comisión (%)</vs-th>
        <vs-th width="120" sort-key="ven_neta">Pedidos Venta Neta</vs-th>
        <vs-th width="120" sort-key="valorComision">Valor comisión</vs-th>
        <vs-th width="120" sort-key="totalPagosConvenio">Pagos</vs-th>
        <vs-th width="120" sort-key="xPagar">Por Pagar</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            # {{ tr.id_institucion }} <br>
            {{ tr.nombreInstitucion }} <br>
            <b>Ruc:</b>
            <p>{{ tr.ruc }}</p>
            <b>Contrato:</b>
            <p>{{ tr.contrato_generado }}</p>
            <b>Asesor:</b>
            <p>{{ tr.asesor }}</p>
            <b>Tipo venta:</b>
            <p>{{ tr.tipo_venta_descr }}</p>
            <b>Es Distribuidor:</b>
            <p>{{ tr.EsDistribuidor }}</p>
            <b>Convenio global:</b>
            <p>{{ tr.totalConvenioAprobado }}</p>
          </vs-td>
          <vs-td>
            <vx-tooltip
              :text="`Total Pedidos: ${tr.ventaPedido.toFixed(2)} | Total Alcance: ${tr.ventaAlcance.toFixed(2)}`"
              position="top"
              color="primary"
            >
              {{ tr.ventaBruta | filtrarDecimal }}
            </vx-tooltip>
          </vs-td>
          <vs-td>{{ tr.comision }}%</vs-td>
          <vs-td>{{ tr.ven_neta.toFixed(2) }}</vs-td>
          <vs-td>
            {{ tr.valorComision | filtrarDecimal }}
          </vs-td>
          <vs-td>
            <vx-tooltip
              :text="`Total Pagos: ${tr.totalPagos.toFixed(2)} | Total Convenio: ${tr.totalConvenioAprobado.toFixed(2)}`"
              position="top"
              color="primary"
            >
              {{ tr.totalPagosConvenio.toFixed(2) }}
            </vx-tooltip>
          </vs-td>
          <vs-td>{{ tr.xPagar.toFixed(2) }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import Generalmix from '../../../../../mixins/Generalmix';
import Codigosmix from "@/mixins/Codigosmix";
import vSelect from 'vue-select'
export default {
  mixins: [Generalmix, Codigosmix],
  components: { vSelect },
  data() {
    return {
      arrayReporte: [],
      showTable: true,
      filtroDistribuidor: 'no',
      opcionesDistribuidor: [
        { label: 'Todos', value: 'todos' },
        { label: 'Solo distribuidores', value: 'si' },
        { label: 'Sin distribuidores', value: 'no' },
      ],
      tipoVenta:3,
    }
  },
  computed: {
    arrayFiltrado() {
      if (this.filtroDistribuidor === 'no') return this.arrayReporte.filter(i => i.EsDistribuidor != 'SI');
      if (this.filtroDistribuidor === 'si') return this.arrayReporte.filter(i => i.EsDistribuidor == 'SI');
      return this.arrayReporte; // "todos"
    },
    totalVentaBruta() { return this.arrayFiltrado.reduce((acc,i)=>acc+(parseFloat(i.ventaBruta)||0),0); },
    totalVentaNeta() { return this.arrayFiltrado.reduce((acc,i)=>acc+(parseFloat(i.ven_neta)||0),0); },
    totalPagosConvenio() { return this.arrayFiltrado.reduce((acc,i)=>acc+(parseFloat(i.totalPagosConvenio)||0),0); },
    totalPorPagar() { return this.arrayFiltrado.reduce((acc,i)=>acc+(parseFloat(i.xPagar)||0),0); },
    totalValorComision() { return this.arrayFiltrado.reduce((acc,i)=>acc+(parseFloat(i.valorComision)||0),0); },
  },
  props: {
    periodo_id: { type: Number, default: 0 },
    nombrePeriodo: { type: String, default: '' }
  },
  methods: {
    f_getReporte() {
      let me = this;
      me.$vs.loading();
      this.$http.get(this.$server_url + `metodosGetVentas?GetReportePedidosPagos=1&periodo=${this.periodo_id}&tipoVenta=${this.tipoVenta}`)
        .then(res => {
          me.$vs.loading.close();
          if (res.data.status == 0) this.m_message(res.data.message,'danger');
          else this.arrayReporte = res.data;
        }).catch(err => {
          me.$vs.loading.close();
          console.log(err);
          me.m_message('Error al obtener el reporte','danger');
        });
    },
    f_exportar() {
      // Determinar el número máximo de beneficiarios
      let maxBeneficiarios = 0;
      this.arrayFiltrado.forEach(item => {
        if (item.beneficiarios && Array.isArray(item.beneficiarios)) {
          maxBeneficiarios = Math.max(maxBeneficiarios, item.beneficiarios.length);
        }
      });

      // Headers base
      let headers = ['Asesor','Institución','Ruc','Contrato','Tipo venta','Venta Bruta','Comisión (%)','Pedidos Venta Neta','Valor comision','Pagos','Por Pagar','Punto de venta','Es Distribuidor','Convenio Global'];
      let fieldKeys = ['asesor','nombreInstitucion','ruc','contrato_generado','tipo_venta_descr','ventaBruta','comision','ven_neta','valorComision','totalPagosConvenio','xPagar','punto_venta','EsDistribuidor','totalConvenioAprobado'];

      // Agregar headers dinámicos para beneficiarios
      for (let i = 1; i <= maxBeneficiarios; i++) {
        headers.push(`Beneficiario ${i}`, `Cédula Beneficiario ${i}`);
        fieldKeys.push(`beneficiario_${i}`, `cedula_beneficiario_${i}`);
      }

      // Preparar datos con beneficiarios expandidos
      const datosExpandidos = this.arrayFiltrado.map(item => {
        const itemExpandido = { ...item };

        // Agregar beneficiarios como propiedades individuales
        if (item.beneficiarios && Array.isArray(item.beneficiarios)) {
          item.beneficiarios.forEach((beneficiario, index) => {
            const num = index + 1;
            itemExpandido[`beneficiario_${num}`] = beneficiario.beneficiario || '';
            itemExpandido[`cedula_beneficiario_${num}`] = beneficiario.cedula || '';
          });
        }

        // Llenar campos vacíos para beneficiarios que no existen
        for (let i = 1; i <= maxBeneficiarios; i++) {
          if (!itemExpandido[`beneficiario_${i}`]) {
            itemExpandido[`beneficiario_${i}`] = '';
            itemExpandido[`cedula_beneficiario_${i}`] = '';
          }
        }

        return itemExpandido;
      });

      const nombreArchivo = `Reporte_ContratosPagos_${this.nombrePeriodo||'Periodo'}.xlsx`;
      this.m_exportTodo(headers, fieldKeys, datosExpandidos, nombreArchivo);
    }
  }
}
</script>
